import { render, staticRenderFns } from "./SampleNavbar.vue?vue&type=template&id=0cbbfb5c&scoped=true&"
import script from "./SampleNavbar.vue?vue&type=script&lang=js&"
export * from "./SampleNavbar.vue?vue&type=script&lang=js&"
import style0 from "./SampleNavbar.vue?vue&type=style&index=0&id=0cbbfb5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbbfb5c",
  null
  
)

export default component.exports